module.exports = __webpack_public_path__ + "img/startConfigurationMemoires.7cd96ab.png";